import { render, staticRenderFns } from "./LoginAzure.vue?vue&type=template&id=1a0855ac&scoped=true"
import script from "./LoginAzure.vue?vue&type=script&lang=js"
export * from "./LoginAzure.vue?vue&type=script&lang=js"
import style0 from "./LoginAzure.vue?vue&type=style&index=0&id=1a0855ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0855ac",
  null
  
)

export default component.exports